import request from '@/utils/request';

export function postMethod(url, obj) {
  return request({
    url,
    data: obj,
    method: 'post'
  })
}
export function getMethod(url, obj) {
  return request({
    url,
    params: obj
  })
}
export function getMb(obj) {
  return request({
    url: "/CqjyWdmb/selectCqjyXxmbAndCqjyWdmbMbnrBymblx",
    method: 'post',
    data:obj
  })
}
export function getTaskId(url) {
  return request({
      url: url,
      method: 'get'
  })
}
export function getMethodOnlyUrl(url) {
  return request({
      url: url,
      method: 'get'
  })
}


// WEBPACK FOOTER //
// ./src/api/signUp/signUp.js